exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-container[data-v-7f55ed96]{background:#fff;width:70px;border-style:solid;border-width:1px 0 1px 1px;border-color:#e3d4d4;display:flex}.withdraw-step1[data-v-7f55ed96]{display:flex;color:#363636;margin-bottom:12px}.copy-clip[data-v-7f55ed96]{display:flex;color:#60609b;justify-content:space-around}.split-blocks[data-v-7f55ed96]{margin-bottom:12px}.bsc-info[data-v-7f55ed96]{display:flex;justify-content:space-between}.instructs[data-v-7f55ed96]{display:flex;flex-direction:column;align-items:center;justify-content:center;padding-top:18px;border-top:1px solid #d8d6d6;border-bottom:1px solid #d8d6d6}.or[data-v-7f55ed96]{text-align:center}.step[data-v-7f55ed96]{width:85%;margin-bottom:18px;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7f55ed96","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/private/services/withdraw_steps/WithdrawStep03.vue
// module id = 966
// module chunks = 2